import { render, staticRenderFns } from "./CompaniesStatistics.vue?vue&type=template&id=58478760&"
import script from "./CompaniesStatistics.vue?vue&type=script&lang=js&"
export * from "./CompaniesStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesStatistics.vue?vue&type=style&index=0&id=58478760&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports